import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';

export const infoBarMessageCreatorsMap: {
    // key can be a unique identifier to bucket messages (e.g. per item)
    [key: string]: { [messageId: string]: InfoBarMessageViewStateCreator };
} = {};

export default function getInfoBarMessageCreator(
    key: string,
    messageId: string
): InfoBarMessageViewStateCreator {
    return infoBarMessageCreatorsMap[key] && infoBarMessageCreatorsMap[key][messageId];
}
